import 'twin.macro';
import 'styled-components/macro';
import { useEffect } from 'react';
import * as React from 'react';
import { useLocation } from 'react-router-dom';

import { AppBar, AppBarProps } from './AppBar';
import { NavigationMenu, NavigationMenuProps } from './NavigationMenu';

export interface NavigationProps {
  teamSlug?: string;
  onLogout?: () => void;
  setNavigationMenuOpen: (open: boolean) => void;
  isNavigationMenuOpen: boolean;
  profile?: NavigationMenuProps['profile'] & AppBarProps['profile'];
  renderAnnouncements?: (props: {}) => React.ReactElement<any, any> | null;
  shouldHideAccountActions?: boolean;
  shouldHideContent?: boolean;
  shouldHideInspirationLibrary?: boolean;
  showAdminMenuEntry?: boolean;
  showDocumentationMenuEntry?: boolean;
}

export const Navigation = ({
  teamSlug,
  onLogout,
  setNavigationMenuOpen,
  isNavigationMenuOpen,
  profile,
  renderAnnouncements,
  shouldHideAccountActions,
  shouldHideContent,
  shouldHideInspirationLibrary,
  showAdminMenuEntry,
  showDocumentationMenuEntry,
}: NavigationProps) => {
  const location = useLocation();

  // Close any of the open sub menus when navigating to a new page.
  useEffect(() => {
    setNavigationMenuOpen(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <div tw="w-full relative">
      <AppBar
        teamSlug={teamSlug}
        onOpen={() => setNavigationMenuOpen(true)}
        open={isNavigationMenuOpen}
        profile={profile}
        renderAnnouncements={renderAnnouncements}
        shouldHideAccountActions={shouldHideAccountActions}
        shouldHideContent={shouldHideContent}
        shouldHideInspirationLibrary={shouldHideInspirationLibrary}
      />
      {isNavigationMenuOpen && (
        <NavigationMenu
          teamSlug={teamSlug}
          onLogout={onLogout}
          profile={profile}
          shouldHideAccountActions={shouldHideAccountActions}
          shouldHideContent={shouldHideContent}
          shouldHideInspirationLibrary={shouldHideInspirationLibrary}
          showAdminMenuEntry={showAdminMenuEntry}
          showDocumentationMenuEntry={showDocumentationMenuEntry}
          onClose={() => setNavigationMenuOpen(false)}
        />
      )}
    </div>
  );
};
